import(/* webpackMode: "eager" */ "/app/fe/src/app/error.tsx");
